export var staticJson = [
    {
        market_holidays: {
            Forex: {
                "All FX pairs": { /*'small' : '(Except For RUB Pairs)',*/ Open: "00:05 Mon", Close: "24:00 Fri", Break: "00:00–00:05 Daily" },
                // 'RUB Pairs' : {'Open' : '00:05 Mon','Close' : '24:00 Fri','Break' : '00:00–00:05 Daily'}
            },
            Indices: {
                "All Indices (Except E35EUR)": { Open: "01:00 Mon", Close: "24:00 Fri", Break: "00:00-01:00 Daily" },
                // 'F40EUR' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                // 'D30EUR' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                // 'U30USD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                // 'SPXUSD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                // 'NASUSD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                // '225JPY' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                // '200AUD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                // 'E50EUR' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                // 'H50HKD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                E35EUR: { Open: "09:00 Mon", Close: "21:00 Fri", Break: "21:00-09:00 Daily" },
            },
            Commodities: {
                "All Commodities (Except UKOUSD)": { Open: "01:00 Mon", Close: "24:00 Fri", Break: "00:00-01:00 Daily" },
                // 'USOUSD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
                UKOUSD: { Open: "03:00 Mon", Close: "24:00 Fri", Break: "00:00-03:00 Daily" },
                /*'XNGUSD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
            'XAGUSD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
            'XAUAUD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
            'XAUEUR' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},
            'XAGAUD' : {'Open' : '01:00 Mon','Close' : '24:00 Fri','Break' : '00:00 - 01:00 Daily'},*/
            },
        },
        demoEvents: [
            {
                start: "",
                title: "",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/1/1",
                title: "New Year",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/1/20",
                title: "(US) Dr. Martin Luther King, Jr.",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/2/17",
                title: "(US) Presidents Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/4/10",
                title: "Good Friday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Closed" },
                        { name: "Silver", time: "Closed" },
                        { name: "USOUSD", time: "Closed" },
                        { name: "UKOUSD", time: "Closed" },
                        { name: "Natural Gas", time: "Closed" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Closed" },
                        { name: "200AUD", time: "Closed" },
                        { name: "D30EUR", time: "Closed" },
                        { name: "E35EUR", time: "Closed" },
                        { name: "E50EUR", time: "Closed" },
                        { name: "F40EUR", time: "Closed" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "Closed" },
                        { name: "NASUSD", time: "Closed" },
                        { name: "SPXUSD", time: "Closed" },
                        { name: "U30USD", time: "Closed" },
                    ],
                },
            },
            {
                start: "2020/4/30",
                title: "Hong Kong Labour Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/5/1",
                title: "Europe Labour Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Closed" },
                        { name: "E35EUR", time: "Closed" },
                        { name: "E50EUR", time: "Closed" },
                        { name: "F40EUR", time: "Closed" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/5/25",
                title: "(US) Memorial Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/5/8",
                title: "UK Public Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Closed" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/7/3",
                title: "(US) Independence Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/12/25",
                title: "Christmas",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/4/9",
                title: "Easter Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "01:00 - 17:00" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/4/13",
                title: "Easter Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Closed" },
                        { name: "200AUD", time: "Closed" },
                        { name: "D30EUR", time: "Closed" },
                        { name: "E35EUR", time: "Closed" },
                        { name: "E50EUR", time: "Closed" },
                        { name: "F40EUR", time: "Closed" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/8/31",
                title: "UK Summer Bank Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Closed" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2020/9/7",
                title: "US Labor Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "01:00 - 20:00" },
                        { name: "Silver", time: "01:00 - 20:00" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "01:00 - 20:00" },
                        { name: "NASUSD", time: "01:00 - 20:00" },
                        { name: "SPXUSD", time: "01:00 - 20:00" },
                        { name: "U30USD", time: "01:00 - 20:00" },
                    ],
                },
            },
            {
                start: "2020/10/1",
                title: "Hong Kong Public Holiday ",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "01:00 - 20:00" },
                        { name: "Silver", time: "01:00 - 20:00" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "01:00 - 20:00" },
                        { name: "NASUSD", time: "01:00 - 20:00" },
                        { name: "SPXUSD", time: "01:00 - 20:00" },
                        { name: "U30USD", time: "01:00 - 20:00" },
                    ],
                },
            },
            {
                start: "2020/10/2",
                title: "Hong Kong Public Holiday ",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "01:00 - 20:00" },
                        { name: "Silver", time: "01:00 - 20:00" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "01:00 - 20:00" },
                        { name: "NASUSD", time: "01:00 - 20:00" },
                        { name: "SPXUSD", time: "01:00 - 20:00" },
                        { name: "U30USD", time: "01:00 - 20:00" },
                    ],
                },
            },
            {
                start: "2020/11/26",
                title: "US Thanksgiving Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "01:00 - 20:00" },
                        { name: "Silver", time: "01:00 - 20:00" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "01:00 - 20:00" },
                        { name: "NASUSD", time: "01:00 - 20:00" },
                        { name: "SPXUSD", time: "01:00 - 20:00" },
                        { name: "U30USD", time: "01:00 - 20:00" },
                    ],
                },
            },
            {
                start: "2020/11/27",
                title: "US Thanksgiving Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "01:00 - 20:45" },
                        { name: "Silver", time: "01:00 - 20:45" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "01:00 - 20:45" },
                        { name: "NASUSD", time: "01:00 - 20:45" },
                        { name: "SPXUSD", time: "01:00 - 20:45" },
                        { name: "U30USD", time: "01:00 - 20:45" },
                    ],
                },
            },
            {
                start: "2021/1/18",
                title: "US Martin Luther King Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "01:00 - 20:00" },
                        { name: "Silver", time: "01:00 - 20:00" },
                        { name: "USOUSD", time: "01:00 - 19:45" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "01:00 - 19:45" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "01:00 - 20:00" },
                        { name: "NASUSD", time: "01:00 - 20:00" },
                        { name: "SPXUSD", time: "01:00 - 20:00" },
                        { name: "U30USD", time: "01:00 - 20:00" },
                    ],
                },
            },
            {
                start: "2021/1/26",
                title: "The Australia Day Public Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "08:10 - 24:00" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2021/2/11",
                title: "HK Lunar New Year & Presidents Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "03:15 - 06:00" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2021/2/12",
                title: "HK Lunar New Year & Presidents Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2021/2/15",
                title: "HK Lunar New Year & Presidents Day",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "01:00 - 20:00" },
                        { name: "Silver", time: "01:00 - 20:00" },
                        { name: "USOUSD", time: "01:00 - 19:45" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "01:00 - 19:45" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Normal" },
                        { name: "200AUD", time: "Normal" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "Normal" },
                        { name: "F40EUR", time: "Normal" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2021/4/1",
                title: "Easter Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "01:00 – 23:00" },
                        { name: "200AUD", time: "01:00  – 16:00" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "01:00  – 23:00" },
                        { name: "F40EUR", time: "01:00  – 23:00" },
                        { name: "H50HKD", time: "Normal" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2021/4/2",
                title: "Easter Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Closed" },
                        { name: "Silver", time: "Closed" },
                        { name: "USOUSD", time: "Closed" },
                        { name: "UKOUSD", time: "Closed" },
                        { name: "Natural Gas", time: "Closed" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Closed" },
                        { name: "200AUD", time: "Closed" },
                        { name: "D30EUR", time: "Closed" },
                        { name: "E35EUR", time: "Closed" },
                        { name: "E50EUR", time: "Closed" },
                        { name: "F40EUR", time: "Closed" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "01:00  – 16:15" },
                        { name: "NASUSD", time: "01:00  – 16:15" },
                        { name: "SPXUSD", time: "01:00  – 16:15" },
                        { name: "U30USD", time: "01:00  – 16:15" },
                    ],
                },
            },
            {
                start: "2021/4/5",
                title: "Easter Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "Closed" },
                        { name: "200AUD", time: "Closed" },
                        { name: "D30EUR", time: "Closed" },
                        { name: "E35EUR", time: "Closed" },
                        { name: "E50EUR", time: "Closed" },
                        { name: "F40EUR", time: "Closed" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
            {
                start: "2021/4/6",
                title: "Easter Holiday",
                cssClass: "family",
                desc: {
                    Symbols: [
                        { name: "FX Pairs", time: "Normal" },
                        { name: "RUB Pairs", time: "Normal" },
                    ],
                    Commodities: [
                        { name: "Gold", time: "Normal" },
                        { name: "Silver", time: "Normal" },
                        { name: "USOUSD", time: "Normal" },
                        { name: "UKOUSD", time: "Normal" },
                        { name: "Natural Gas", time: "Normal" },
                    ],
                    Indices: [
                        { name: "100GBP", time: "03:00 – 24:00" },
                        { name: "200AUD", time: "02:50 – 24:00" },
                        { name: "D30EUR", time: "Normal" },
                        { name: "E35EUR", time: "Normal" },
                        { name: "E50EUR", time: "03:15 – 24:00" },
                        { name: "F40EUR", time: "09:00 – 24:00" },
                        { name: "H50HKD", time: "Closed" },
                        { name: "22JPY", time: "Normal" },
                        { name: "NASUSD", time: "Normal" },
                        { name: "SPXUSD", time: "Normal" },
                        { name: "U30USD", time: "Normal" },
                    ],
                },
            },
        ],
        leverage: {
            "Forex (Majors)": {
                Retail: "30X",
                Professional: "UP TO 500X",
            },
            forex_detail_major: {
                detail: ["EURUSD", "EURGBP", "EURJPY", "EURCAD", "EURCHF", "USDJPY", "GBPUSD", "USDCAD", "USDCHF", "GBPJPY", "CADJPY", "CHFJPY", "GBPCAD", "CADCHF", "GBPCHF"],
            },
            "Forex (Minors & Exotics)": {
                Retail: "20X",
                Professional: "UP TO 300X",
            },
            forx_detail_minor: {
                detail: [
                    "AUDCAD",
                    " AUDCHF",
                    " USDZAR",
                    " AUDUSD",
                    " USDTRY",
                    " USDSGD",
                    " USDSEK",
                    " EURAUD",
                    " USDPLN",
                    " USDNOK",
                    " EURCZK",
                    " EURDKK",
                    " USDHKD",
                    " EURNZD",
                    " USDCZK",
                    " USDCNH",
                    " EURNOK",
                    " EURPLN",
                    " NZDUSD",
                    " EURSEK",
                    " NZDJPY",
                    " EURTRY",
                    " NZDCHF",
                    " NZDCAD",
                    " NOKSEK",
                    " GBPAUD",
                    " GBPZAR",
                    " GBPTRY",
                    " GBPDKK",
                    " GBPSEK",
                    " GBPPLN",
                    " GBPNZD",
                    " GBPNOK",
                    " USDDKK",
                    " AUDNZD",
                    " EURMXN",
                    " EURHKD",
                    " EURSGD",
                    " EURZAR",
                    " USDMXN",
                    " USDHUF",
                    " EURHUF",
                    " GBPHUF",
                    " GBPMXN",
                    " EURRUB",
                    " GBPCZK",
                    " NZDSGD",
                    " USDRUB",
                    " GBPSGD",
                    " GBPHKD",
                    " AUDJPY",
                    " USDRON",
                    " USDILS",
                    " EURRON",
                    " USDTHB",
                ],
            },
            "Gold ": {
                Retail: "20X",
                Professional: "UP TO 500X",
            },
            gold_detail: {
                detail: ["XAUUSD"],
            },
            "Precious Metals (Others)": {
                Retail: "10X",
                Professional: "UP TO 500X",
            },
            precious_metal_detail: {
                detail: ["XAGUSD", "XAUAUD", "XAUEUR", "XAGAUD"],
            },
            "Energy Spot": {
                Retail: "10X",
                Professional: "UP TO 500X",
            },
            Energy_spot_detail: {
                detail: ["USOUSD", "UKOUSD", "XNGUSD"],
            },
            "Major Indices": {
                Retail: "20X",
                Professional: "UP TO 500X",
            },
            major_indices_detail: {
                detail: ["100GBP", "F40EUR", "D30EUR", "U30USD", "SPXUSD", "NASUSD", "225JPY", "200AUD", "E50EUR"],
            },
            "Minor Indices": {
                Retail: "10X",
                Professional: "UP TO 300X",
            },
            Minor_Indices: {
                detail: ["H50HKD", "E35EUR"],
            },
        },
        commodity_leverage: [
            { Open_Lots: "0-100", Maximum_Leverage: "500X" },
            { Open_Lots: "100-200", Maximum_Leverage: "250X" },
            { Open_Lots: "above 200", Maximum_Leverage: "100X" },
        ],
        indices_leverage: [
            { Open_Lots: "0-500", Maximum_Leverage: "500X" },
            { Open_Lots: "500-2000", Maximum_Leverage: "250X" },
            { Open_Lots: "above 2000", Maximum_Leverage: "100X" },
        ],
    },
];



//////////////////
// WEBPACK FOOTER
// ./static/fxView/js/staticJson.js
// module id = null
// module chunks = 